import React from 'react'
import {Link} from '@miro-site/core'
import {LinkColors as CoreLinkColors} from '@miro-site/core'

import {LinkOptions, LinkColors} from './types'

const COLORS: Record<LinkColors, CoreLinkColors> = {
  white: 'white',
  indigo: 'indigo',
  dark: 'default',
  yellow: 'yellow',
  pink: 'pink',
} as const

const LinkAdapter: React.FC<LinkOptions & React.ComponentProps<typeof Link>> = ({
  color = 'default',
  href = '#',
  text,
  simple_link,
  ...rest
}) => {
  if (simple_link) {
    return (
      <Link href={href} {...rest}>
        {text}
      </Link>
    )
  }
  return (
    <Link $variant="default" $size="default" href={href} $color={COLORS[color]} {...rest}>
      {text}
    </Link>
  )
}

export default LinkAdapter
